import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { RefreshOutlined, Home } from '@mui/icons-material';
import ErrorHandler from '../services/errorHandler';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    ErrorHandler.logError(error, 'ErrorBoundary', { componentStack: errorInfo.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm">
          <Box
            sx={{
              minHeight: '60vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              gap: 3,
              py: 8,
            }}
          >
            <Typography variant="h1" sx={{ fontSize: '4rem', mb: 0 }}>
              😵
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Oups, quelque chose s'est mal passé
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Une erreur inattendue est survenue. Essayez de rafraîchir la page.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
              <Button
                variant="contained"
                startIcon={<RefreshOutlined />}
                onClick={() => window.location.reload()}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  bgcolor: 'primary.main',
                }}
              >
                Rafraîchir la page
              </Button>
              <Button
                variant="outlined"
                startIcon={<Home />}
                onClick={() => { window.location.href = '/'; }}
                sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
              >
                Retour à l'accueil
              </Button>
            </Box>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

